var React = require('react');

function DifficultyLevelGreenWhiteOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.5 10.5C20.5 16.0228 16.0228 20.5 10.5 20.5C4.97715 20.5 0.5 16.0228 0.5 10.5C0.5 4.97715 4.97715 0.5 10.5 0.5C16.0228 0.5 20.5 4.97715 20.5 10.5Z","fill":"#8DC53E","stroke":"white"}));
}

DifficultyLevelGreenWhiteOutline.defaultProps = {"viewBox":"0 0 21 21","fill":"none"};

module.exports = DifficultyLevelGreenWhiteOutline;

DifficultyLevelGreenWhiteOutline.default = DifficultyLevelGreenWhiteOutline;
